const setOnFocusHandler = (handler) => window.onfocus = handler;
const setOnBlurHandler = (handler) => window.onblur = handler;
const setOnLoadHandler = (handler) => window.onload = handler;

const hasFocus = () => document.hasFocus();
const hasInternet = () => navigator.onLine;

const DOMUtils = {
  setOnFocusHandler,
  setOnBlurHandler,
  setOnLoadHandler,
  hasFocus,
  hasInternet,
};

export default DOMUtils;
